class ApiError extends Error {
    constructor(errorCode, message, errors) {
        super(message);
        this.name = this.constructor.name;
        this.status = 0;
        this.message = message;
        this.errorCode = errorCode;
        this.errors = errors;
        this.stack = (new Error()).stack;
    }
}

const retornoApi = (response, useDataData = true) => {
    if (response && response.data && response.data.data && useDataData) {
        if (!response.data.data.hasOwnProperty('status')) {
            response.data.data.status = 1;
        }
        return response.data.data;
    } else if (response && response.data) {
        if (!response.data.hasOwnProperty('status')) {
            response.data.status = 1;
        }
        return response.data;
    }
    if (!response.hasOwnProperty('status')) {
        response.status = 1;
    }
    return response;
};

const retornoApiError = (error) => {
    if (error.response && error.response.data && error.response.data.errors) {
        return new ApiError(error.response.status, error.response.data.message, error.response.data.errors);
    } else if (error.response && error.response.data) {
        return new ApiError(error.response.status, error.response.data.message, {});
    } else if (typeof error.response !== "undefined" && error.response.message) {
        return new ApiError(error.response.status, error.response.message, {});
    } else if (typeof error.response !== "undefined") {
        return new ApiError(error.response.status, error.response.statusText, {});
    }
    return new ApiError(0, error.message, {});
};

export {ApiError, retornoApi, retornoApiError};
